export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/hightolow.28ededc4.svg","height":15,"width":20,"blurWidth":0,"blurHeight":0};